module.exports = __webpack_public_path__ + "static/media/Shenandoah-FrontElevation.2beb0f7b.jpg";